import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ContactSection } from '../../components/contact-section/contact-section';
import { SeoService } from '../../services/seo.service';
import { createAboutPageSchema } from '../../data/structured-data';

@Component({
  selector: 'app-about',
  imports: [ContactSection],
  templateUrl: './about.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './about.scss',
})
export class About {
  private readonly seoService = inject(SeoService);
  protected readonly seoTitle = 'Mari Group – About Us';
  protected readonly seoDescription =
    'Discover how Mari Group builds, grows, and scales category-defining live experiences across sport, entertainment, art, and lifestyle.';

  constructor() {
    this.seoService.update({
      title: this.seoTitle,
      description: this.seoDescription,
      jsonLdBlocks: [createAboutPageSchema()],
      breadcrumbItems: [
        { name: 'Home', path: '/' },
        { name: 'About', path: '/about' },
      ],
    });
  }
}
